import React, { useContext } from "react";
import Header from "../../../homepage/components/SectionHeader";
import { musicWinlosesSelector } from "../../../../../libs/redux";
import Provider from "../../../../providers/rating";
import Rating from "../../../../components/rating/component";
import MobileView from "../../../homepage/components/MobileCards";
import { useHistory } from "react-router-dom";
import { I8nContext } from "../../../../../libs/i18n";
import {
  MainStructure, 
  RatingContainer 
} from "app/views/sections/components/layout";

const MusicPreview: React.FC = () => {
  const history = useHistory();
  const handleRoute = () => history.push("/music");
  const { translate } = useContext(I8nContext);

  return (
    <div onClick={handleRoute} className="box">
      <Header title={translate("MUSIC")} />

      <MainStructure className='center'>
          <div className="mobile">
            <Provider selector={musicWinlosesSelector}  Component={MobileView} />
          </div>

          <RatingContainer>
            <Provider selector={musicWinlosesSelector} Component={Rating} preview={true}/>
          </RatingContainer>
      </MainStructure>
   </div>
  );
};

export default MusicPreview;
